module.exports = __webpack_public_path__ + "static/media/8.de3a87da.jpg";